import Cookie from '@shopify/marketing-assets/javascripts/helpers/cookie-helper';

const COOKIE = 'page_count';

function setPageCount(newCount) {
  Cookie.set(COOKIE, newCount, {path: '/'});
  return newCount;
}

export function getPageCount() {
  const count = Cookie.get(COOKIE);
  return count ? parseInt(count, 10) : 0;
}

export function incrementPageCount() {
  const currentCount = getPageCount();
  return setPageCount(currentCount + 1);
}
